import replacementService from "@/services/replacement";
import getClientContact from "@/mixins/getClientContact";
import Utils from "@/mixins/Utils";
export default {
  mixins: [getClientContact, Utils],
  data() {
    return {
      googleApiKey:  window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
      ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
      items: [
        {
          text: this.$t("my-assignment-offer"),
          to: { name: "employee-assignment-offer" },
        },
        // {
        //   text: this.$route.query.message,
        //   active: true,
        // },
      ],
      replacement: {
        ...this.$route.query,
      },
      isShowButton:
        this.$route.query.pkIxCrfReplacementRequest == 0 ? true : false,
      message: "",
      pkReplacementStatus: [
        { value: 0, label: "Non renseigné" },
        { value: 1, label: "En cours" },
        { value: 2, label: "Pourvue" },
        { value: 3, label: "Annulée" },
      ],
      pkIxCrfReplacementRequest: [
        { value: 0, label: "Non renseigné" },
        { value: 1, label: "En Attente" },
        { value: 2, label: "Accepté" },
        { value: 3, label: "Refusé" },
        { value: 4, label: "Validé" },
        { value: 5, label: "Supprimé" },
      ],
      client: undefined
    };
  },
  components: {},
  async mounted() {
    this.client = await this.getClient(this.$route.query.pkCrfClient)
    this.items.push({
      text: `${this.client ? this.client.name: this.$t('no-information')} ${this.$options.filters.formatUnixFullDate(this.replacement.dateDebutMission)} ${this.$options.filters.formatUnixFullDate(this.replacement.dateFinMission)}`,
      active: true,
    })
  },
  methods: {
    getReplacementStatus(status){
      const result = this.pkReplacementStatus.filter(replacement => replacement.value === status)
      if(result.length <= 0) return;
      return result[0].label
    },
    getReplacementRequest(status){
      const result = this.pkIxCrfReplacementRequest.filter(replacement => replacement.value === status)
      if(result.length <= 0) return;
      return result[0].label
    },
    getStaticMapURL(mission) {
      return `https://maps.google.com/maps/api/staticmap?
        center=${mission.lat},${mission.lng}
        &size=365x256&scale=1&sensor=false&zoom=16
        &markers=${mission.lat}%2C${mission.lng}
        &key=${this.googleApiKey}`;
    },
    approve() {
      const vue = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vue
            .approveRequest(vue.replacement.id)
            .then(function(response) {
              if (response) {
                vue.isShowButton = false;
                vue.replacement.pkIxCrfReplacementRequest = 2
              }
            })
            .catch(function(error) {});
        }
      });
    },
    refuse() {
      const vue = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vue
            .refuseRequest(vue.replacement.id)
            .then(function(response) {
              if (response) {
                vue.isShowButton = false;
                vue.replacement.pkIxCrfReplacementRequest = 3
              }
            })
            .catch(function(error) {});
        }
      });
    },
    approveRequest(id) {
      return replacementService.createRequest(id, { message: this.message });
    },
    refuseRequest(id) {
      return replacementService.deleteRequest(id, { message: this.message });
    },
  },
};
